export default "__VITE_ASSET__BUojfnwg__"